<template>
	<div class="transaction-response">
		<Accordion
			title="Transaction Response"
			v-model="showResponseTransaction"
			v-log="{
				event: 'open',
				target: 'TransactionAudit.ResponseViewed',
				eventData: {
					...auditInfo,
					action: 'Viewed',
					target: 'Response'
				}
			}"
		>
			<template #body-content>
				<div class="transaction-response__container">
					<div class="transaction-response__header-actions">
						<ButtonGroup>
							<template slot="container">
								<Button
									className="btn--has-icon btn--small"
									labelText="Download"
									:btnClick="downloadFile"
									:iconClassName="'icon icon-download'"
									:iconBeforeLabel="true"
									:disabled="showButton"
									v-log="{
										event: 'click',
										target:
											'TransactionAudit.ResponseDownload',
										eventData: {
											...auditInfo,
											action: 'Downloaded',
											target: 'Response'
										}
									}"
								></Button>
								<Button
									className="btn--has-icon btn--small"
									labelText="Copy"
									:btnClick="copyResponseTransaction"
									:iconClassName="'icon icon-copy'"
									:iconBeforeLabel="true"
									:disabled="showButton"
									v-log="{
										event: 'click',
										target:
											'TransactionAudit.ResponseCopied',
										eventData: {
											...auditInfo,
											action: 'Copied',
											target: 'Response'
										}
									}"
								></Button>
							</template>
						</ButtonGroup>
					</div>
					<div class="transaction-response__details">
						<Spinner :processor="{ loading: loadingResponse }" />
						<pre>{{ formatToXML(responseTransaction) }}</pre>
					</div>
				</div>
			</template>
		</Accordion>
	</div>
</template>

<script>
import Accordion from '@/components/shells/accordion/accordion';
import ButtonGroup from '@/components/forms/button/button-group';
import Button from '@/components/forms/button/button';
import { copyToClipboard } from '@/utils/function';
import { LoggingMixin } from 'vue-ui-layout';
import ResponseRequestTransaction from '@/sections/transactions/mixins/responseRequestTransaction.js';
import Spinner from '@/components/visual/spinner/spinner';
import store from '@/store';
import _ from 'lodash';

export default {
	name: 'GlobalTransactionsDetailsResponse',
	mixins: [LoggingMixin, ResponseRequestTransaction],
	components: {
		Accordion,
		ButtonGroup,
		Button,
		Spinner
	},
	props: {
		responseBlob: {
			type: String,
			default: ''
		},
		auditInfo: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			showResponseTransaction: false,
			responseTransaction: '',
			loadingResponse: false
		};
	},
	computed: {
		showButton() {
			return _.isEmpty(this.responseBlob);
		}
	},
	methods: {
		async downloadFile() {
			if (this.responseBlob) {
				const responseJson = JSON.parse(this.responseBlob);

				if (!this.responseTransaction) {
					this.responseTransaction = await this.showTransactionRequest(
						responseJson.Uri
					);
				}
				const fileName = !responseJson.Name?.endsWith('.xml')
					? `${responseJson.Name}.xml`
					: responseJson.Name;
				this.downloadXMLTransaction(fileName, this.responseTransaction);
			}
		},
		copyResponseTransaction() {
			if (this.responseTransaction) {
				const responseFormat = this.formatToXML(this.responseTransaction);
				copyToClipboard(responseFormat);

				store.dispatch('toastMessages/push', {
					statusCode: 200,
					message: 'Transaction Response copied to clipboard!!'
				});
			}
		}
	},
	watch: {
		showResponseTransaction: {
			deep: true,
			async handler(val) {
				if (val && !this.responseTransaction) {
					const response =
						this.responseBlob && JSON.parse(this.responseBlob);
					if (response.Uri) {
						this.loadingResponse = true;
						this.responseTransaction = await this.showTransactionRequest(
							response.Uri
						);
						this.loadingResponse = false;
					}
				}
			}
		}
	}
};
</script>

<style lang="scss">
/**
  * Transaction Details - Transaction Response
  * Can use SCSS variables = TRUE
**/

.transaction-response {
	&__header-actions {
		display: flex;
		justify-content: flex-end;
		padding: $padding-md;
		border-bottom: 1px solid $neutral-2;

		@include mq($from: sm-l) {
			padding: $padding-md $padding-lg;
		}
	}

	&__details {
		padding: $padding-md;
		overflow: auto;
		max-height: 180px;
		@include scrollbar;
		font-size: $default-font-size - 4;
	}
}
</style>
